// TODO: remove with https://github.com/combinaut/sparkle/issues/32277 once no admin script or Select2 fires change through jQuery.
// legacy-bridge: https://github.com/combinaut/sparkle/issues/32277
// The one place admin code listens through jQuery: `jQuery.trigger("change")` dispatches no native event, so native
// listeners hear legacy and Select2 changes only through here.
/* eslint-disable no-restricted-globals -- the jQuery bridge */
/* global jQuery */

const handlers = new Set();
let listening = false;

function handOverJQueryChange(event) {
  if (event.originalEvent) {
    return;
  }

  handlers.forEach((handler) => handler(event));
}

/** Calls `handler` with each `change` fired through `jQuery.trigger` anywhere in the document. */
export function onJQueryTriggeredChange(handler) {
  handlers.add(handler);

  if (!listening) {
    jQuery(document).on("change", handOverJQueryChange);
    listening = true;
  }
}

/** Turns Select2's jQuery-fired `change` on `select` into one native `change`. Call it before Select2 binds. */
export function announceSelect2ChangesNatively(select) {
  jQuery(select)
    .off("change.select2-native-change")
    .on("change.select2-native-change", function announceNativeChange(event) {
      if (event.originalEvent) {
        return;
      }

      event.stopImmediatePropagation();
      select.dispatchEvent(new Event("change", { bubbles: true }));
    });

  // First among the select's own handlers, so every `change` handler, bound before or after, hears a Select2 change
  // once, as a native change.
  const changeHandlers = jQuery._data(select, "events").change;

  changeHandlers.splice(changeHandlers.delegateCount, 0, changeHandlers.pop());
}
